import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import BarChart2 from 'assets/icons/BarChart2';
import COLOR from 'constants/color';
import { LOG_SUMMARY_OPTION } from 'constants/general';
import { t } from 'services/i18n.service';
import { updateMoreOptionLogSummaryType } from 'store/reducer/modal/slice';
import { moreOptionModalActivitySelector } from 'store/reducer/modal/more-options.modal.selectors';

const LogType: React.FC = () => {
  const dispatch = useAppDispatch();
  const activity = useAppSelectorShallow(moreOptionModalActivitySelector);
  const logSummaryType =
    activity?.log_summary_type || LOG_SUMMARY_OPTION.SUMMATION;

  const handleChange = (value: string) => {
    dispatch(updateMoreOptionLogSummaryType(value));
  };

  return (
    <div className='flex flex-col ~gap-3/4'>
      <div className='flex items-center ~gap-2/3'>
        <BarChart2 className='~w-4/5 ~h-4/5' fill={COLOR.PRIMARY.LIGHT_900} />
        <h3 className='~text-xs/base text-black dark:text-white'>
          {t('tabs_revamp.log_data_tab.log_type')}
        </h3>
      </div>
      <p className='~text-xs/sm text-gray-600 dark:text-gray-400 ~ml-0/0'>
        {t('tabs_revamp.log_data_tab.log_type_description')}
      </p>
      <div className='flex items-center ~gap-4/6'>
        <label className='flex items-center ~gap-2/3 cursor-pointer'>
          <input
            type='radio'
            name='logSummaryType'
            value={LOG_SUMMARY_OPTION.SUMMATION}
            checked={logSummaryType === LOG_SUMMARY_OPTION.SUMMATION}
            onChange={(e) => handleChange(e.target.value)}
            className='w-4 h-4 text-primary-900 focus:ring-primary-500 focus:ring-2 border-gray-300 dark:border-gray-600'
          />
          <span className='~text-xs/base text-black dark:text-white'>
            {t('tabs_revamp.log_data_tab.total')}
          </span>
        </label>
        <label className='flex items-center ~gap-2/3 cursor-pointer'>
          <input
            type='radio'
            name='logSummaryType'
            value={LOG_SUMMARY_OPTION.AVERAGE}
            checked={logSummaryType === LOG_SUMMARY_OPTION.AVERAGE}
            onChange={(e) => handleChange(e.target.value)}
            className='w-4 h-4 text-primary-900 focus:ring-primary-500 focus:ring-2 border-gray-300 dark:border-gray-600'
          />
          <span className='~text-xs/base text-black dark:text-white'>
            {t('tabs_revamp.log_data_tab.average')}
          </span>
        </label>
      </div>
    </div>
  );
};

export default LogType;
